import { motion } from "framer-motion";
import { Lockup } from "@/components/Brand";

export const Preloader = ({ onDone }) => (
  <motion.div
    className="fixed inset-0 z-[200] flex items-center justify-center bg-plum"
    initial={{ y: 0 }}
    animate={{ y: "-100%" }}
    transition={{ duration: 1, delay: 1.2, ease: [0.76, 0, 0.24, 1] }}
    onAnimationComplete={onDone}
    aria-hidden="true"
    data-testid="preloader"
  >
    <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: [0, 1, 1, 0], scale: 1 }} transition={{ duration: 1.4, times: [0, 0.25, 0.75, 1], ease: "easeOut" }} className="flex flex-col items-center gap-5 ">
      <Lockup height={56} />
      <span className="text-[0.62rem] uppercase tracking-[0.6em] text-white/80">Beauty Awards 2027</span>
    </motion.div>
  </motion.div>
);
